import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleGoogleMediaUpload from '../../../GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { useEditAssetGroupSubmit } from '../../hooks'
import { getLandscapeImageData } from '../HeadlinesSection/helpers'
import { isAllImageAssetsReady } from '../../helpers'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { googleAssetFieldType } from '../../../../../../../constants/ads'
import { getInitialValues } from './fields'
import { LANDSCAPE_IMAGE, landscapeImageHeight, landscapeImageWidth } from '../../../../fields'
import { landscapeImageValidationSchema } from '../../../../validations'
import { validationSchema } from './validation'

const LandscapeImageSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalLandscapeImageAssets = useMemo(() => getLandscapeImageData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalLandscapeImageAssets), [originalLandscapeImageAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalLandscapeImageAssets,
    fieldType: googleAssetFieldType.MARKETING_IMAGE,
    sectionValueKey: LANDSCAPE_IMAGE,
    isInternalAssetGroup,
    assetGroupId,
    initialValues,
    validationSchema,
    title,
    adAccount
  })

  const { values } = purifiedFormik

  const isImagesReady = isAllImageAssetsReady(values, LANDSCAPE_IMAGE)

  const isEmptyList = !values[LANDSCAPE_IMAGE].length

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      submitBtnDisabled={!isImagesReady}
      {...formProps}
    >
      <MultipleGoogleMediaUpload
        formik={purifiedFormik}
        FileItemPath={LANDSCAPE_IMAGE}
        validationSchema={landscapeImageValidationSchema}
        addAnotherButtonText={isEmptyList ? 'Add landscape image' : 'Add another landscape image'}
        width={landscapeImageWidth}
        height={landscapeImageHeight}
      />
    </EditForm>
  )
}

export default LandscapeImageSectionForm
